import {
  Component,
  Inject,
  Input,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import _ from 'lodash';
import { LikeService } from '../../../../services/like.service';
import communityFeedItemLikeListOverlay from '../../../../../components/community/feed/community-feed-item-like-list-overlay.component.html';

@Component({
  selector: 'ut-community-feed-item-like-count',
  templateUrl: './community-feed-item-like-count.component.html',
  standalone: false,
})

export class CommunityFeedItemLikeCountComponent implements OnInit, OnDestroy {
  @Input() likeable: any;
  users: any;
  theModal: any;
  private feedItemLikedListener: () => void;

  constructor(
    @Inject('$uibModal') private $uibModal: any,
    private LikeService: LikeService,
    @Inject('FeedStore') private FeedStore: any,
    @Inject('$scope') private $scope: ng.IScope,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.users = this.FeedStore.create(_.bind(this.LikeService.likedUsers, this.LikeService, this.likeable));

    // Listen for like/unlike events and trigger change detection
    this.feedItemLikedListener = this.$scope.$on('feedItemLiked', (event, likeable) => {
      if (likeable.id === this.likeable.id && likeable.type === this.likeable.type) {
        this.cdr.markForCheck();
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up the event listener
    if (this.feedItemLikedListener) {
      this.feedItemLikedListener();
    }
  }

  showLikes() {
    this.users.load();
    this.theModal = this.$uibModal.open({
      animation: true,
      template: communityFeedItemLikeListOverlay,
      controller: 'ModalCtrl',
      windowClass: 'community-modal',
      resolve: {
        data: () => ({
          likedUsers: this.users,
          likeable: this.likeable,
          closeOverlay: () => {
            this.theModal.close();
          },
        }),
      },
    }).result.catch((resp) => {
      if (['cancel', 'backdrop click', 'escape key press'].indexOf(resp) === -1) throw resp;
    });
  }
}
